import React, { useEffect, useMemo, useRef, useState } from "react";
import { cdnImg } from "../../Utils/cdnImage";
// import useDynamicCSS from "../../component/useDynamicCss";
// import { FaMinus, FaPlus } from "react-icons/fa";
import BetSlipContext from "../../context/BetSlipContext";
import { useContextSelector } from "use-context-selector";
import { inRange, isEmpty, startCase, upperCase } from "lodash";
import AuthContext from "../../context/AuthContext";
import StackSetting from "../../component/StackSetting";
import { formatWithCommas } from "../../Utils/Toast";
import { isMobile } from "react-device-detect";
import ThemeContext from "../../context/ThemeContext";
import OutsideClickHandler from "react-outside-click-handler";
const BetSlip = () => {
  const numberArray = [10, 100, 200, 500];
  const numberArrayCount = [1, 2, 3, 4, 5, 6, 7, 8, 9, 0, "00", "."];
  // let loader = useDynamicCSS(useMemo(() => ["/assets/css/betslip.css"], []));
  const user = useContextSelector(AuthContext, (ctx) => {
    return ctx.user;
  });
  const setBetSlipObject = useContextSelector(BetSlipContext, (ctx) => {
    return ctx.setBetSlipObject;
  });
  const theme = useContextSelector(ThemeContext, (ctx) => {
    return ctx.theme;
  });
  const betSlipObject = useContextSelector(BetSlipContext, (ctx) => {
    return ctx.betSlipObject;
  });
  const betLoader = useContextSelector(BetSlipContext, (ctx) => {
    return ctx.betLoader;
  });
  const profileData = useContextSelector(AuthContext, (ctx) => {
    return ctx.profileData;
  });

  const limit = useContextSelector(BetSlipContext, (ctx) => {
    return ctx.limit;
  });
  const setShowBetDialog = useContextSelector(BetSlipContext, (ctx) => {
    return ctx.setShowBetDialog;
  });
  const showBetDialog = useContextSelector(BetSlipContext, (ctx) => {
    return ctx.showBetDialog;
  });
  const setResetBetPosition = useContextSelector(BetSlipContext, (ctx) => {
    return ctx.setResetBetPosition;
  });
  const handelPlaceBetFair = useContextSelector(BetSlipContext, (ctx) => {
    return ctx.handelPlaceBetFair;
  });
  const handelPlaceFancy = useContextSelector(BetSlipContext, (ctx) => {
    return ctx.handelPlaceFancy;
  });
  const handelPlaceBookmaker = useContextSelector(BetSlipContext, (ctx) => {
    return ctx.handelPlaceBookmaker;
  });
  const setLoginModal = useContextSelector(BetSlipContext, (ctx) => {
    return ctx.setLoginModal;
  });
  const handelPlaceSportBook = useContextSelector(BetSlipContext, (ctx) => {
    return ctx.handelPlaceSportBook;
  });

  const handelPlaceToss = useContextSelector(BetSlipContext, (ctx) => {
    return ctx.handelPlaceToss;
  });
  const [bidPriceDisabled, setBidPricDisabled] = useState(true);
  const [setting, setSetting] = useState(false);
  useEffect(() => {
    if (
      inRange(
        Number(betSlipObject?.bidPrice),
        limit?.minAmount || 1,
        limit?.maxAmount + 1 || 100,
      )
    ) {
      setBidPricDisabled(false);
    } else {
      setBidPricDisabled(true);
    }
  }, [betSlipObject, limit]);
  const placeBet = () => {
    if (!isEmpty(user)) {
      if (
        betSlipObject?.playType == "betFaire" ||
        betSlipObject?.playType == "multi" ||
        betSlipObject?.playType == "home"
      ) {
        handelPlaceBetFair();
      } else if (betSlipObject?.playType == "fancy") {
        handelPlaceFancy();
      } else if (betSlipObject?.playType == "bookmaker") {
        handelPlaceBookmaker();
      } else if (betSlipObject?.playType == "sportBook") {
        handelPlaceSportBook();
      } else if (betSlipObject?.playType == "toss") {
        handelPlaceToss();
      }
    } else {
      setShowBetDialog(false);
      setLoginModal(true);
    }
  };

  const inputRef = useRef(null);
  const [activeInput, setActiveInput] = useState(null); // 1 or 2

  useEffect(() => {
    if (inputRef.current) {
      inputRef.current.focus();
    }
  }, [activeInput]);

  return (
    <>
      <div
        data-v-5a681009
        id="bet-slip"
        className={`s-z-70 s-bottom-0 s-rounded-t-xl s-transition-all s-duration-700 ${isMobile ? "s-fixed s-w-full" : "s-sticky s-w-desktop"}  ${
          !showBetDialog ? "s-translate-y-full s-opacity-0" : "s-opacity-100"
        } `}
        style={{ "z-index": "9999999999", left: "0" }}
      >
        <div
          data-v-5a681009
          style={{ display: showBetDialog ? "block" : "none" }}
          className="s-bg-betSlip-light dark:s-bg-betSlip-dark s-relative s-p-2 s-rounded-t-5px s-z-10"
        >
          <div
            data-v-5a681009
            className="s-flex s-items-center s-font-bold s-mb-2"
          >
            {!["fancy", "sportBook", "toss"].includes(
              betSlipObject?.playType,
            ) && (
              <span
                data-v-5a681009
                className={`s-relative s-w-50px s-py-2 s-inline-block s-font-bold s-text-center s-text-15px s-rounded-3px s-shrink-0 ${
                  ["lay", "No"].includes(betSlipObject?.betType)
                    ? "s-bg-lay dark:s-bg-lay-500"
                    : "s-bg-back-200 dark:s-bg-back-500"
                } `}
              >
                {startCase(betSlipObject?.betType)}
              </span>
            )}

            <span
              data-v-5a681009
              className="s-inline-block s-text-global-font-default-light dark:s-text-global-font-default-dark s-text-18px s-leading-120 s-align-text-bottom s-px-2 s-mr-6 s-break-all s-grow"
            >
              {betSlipObject?.teamName}
            </span>
            <div
              onClick={() => {
                setShowBetDialog(false);
                setResetBetPosition(true);
              }}
              data-v-5a681009
              className="s-icon-close s-absolute s-right-2 s-mr-2 s-text-global-font-default-light dark:s-text-global-font-default-dark s-text-base s-flex s-justify-center s-items-center s-cursor-pointer"
            />
          </div>
          {/**/}
          <div data-v-5a681009 className="s-flex">
            <section
              style={{ background: "#20232a" }}
              data-v-5a681009
              className="s-bet-amount bg-black-100"
            >
              <p data-v-5a681009 className="s-title s-font-normal">
                Odds
              </p>
              <div data-v-5a681009 className="s-input-box">
                <button
                  data-v-bf7df09e
                  style={
                    theme == "light"
                      ? { background: "#d4e0e5", color: "black" }
                      : {}
                  }
                  data-v-5a681009
                  className="btn s-btn-normal s-relative s-text-14px s-p-3 s-font-bold s-rounded s-flex s-justify-center s-items-center disabled:s-bg-black-300 dark:disabled:s-bg-black-700 disabled:s-text-black-600 dark:disabled:s-text-black-600 disabled:s-cursor-not-allowed s-overflow-hidden a active:s-bg-opacity-10 s-w-34px s-h-34px"
                  disabled
                  name="minus"
                >
                  <div
                    data-v-2f9c23fd
                    data-v-bf7df09e
                    className="wrapper s-w-full s-h-full s-absolute s-overflow-hidden s-top-0 s-left-0 s-z-10"
                    style={{ "--0b879273": "0" }}
                  >
                    <span
                      data-v-2f9c23fd
                      className="mask s-w-full s-h-full s-opacity-10 s-bg-black-900 s-absolute s-left-0 s-top-0"
                      style={{ display: "none" }}
                    />
                    <span
                      data-v-2f9c23fd
                      className="feedback s-block s-bg-white s-bg-opacity-25 s-rounded-full s-mix-blend-overlay s-absolute"
                      style={{ display: "none" }}
                    />
                  </div>
                  {/**/}
                  <span
                    data-v-5a681009
                    className="s-icon-minus s-text-20px s-text-black-600"
                  />
                </button>
                <span
                  data-v-5a681009
                  name="odds"
                  className="s-input-field is-disabled"
                >
                  {betSlipObject?.odds}
                </span>
                <button
                  style={
                    theme == "light"
                      ? { background: "#d4e0e5", color: "black" }
                      : {}
                  }
                  data-v-bf7df09e
                  data-v-5a681009
                  className="btn s-btn-normal s-relative s-text-14px s-p-3 s-font-bold s-rounded s-flex s-justify-center s-items-center disabled:s-bg-black-300 dark:disabled:s-bg-black-700 disabled:s-text-black-600 dark:disabled:s-text-black-600 disabled:s-cursor-not-allowed s-overflow-hidden a active:s-bg-opacity-10 s-w-34px s-h-34px"
                  disabled
                  name="plus"
                >
                  <div
                    data-v-2f9c23fd
                    data-v-bf7df09e
                    className="wrapper s-w-full s-h-full s-absolute s-overflow-hidden s-top-0 s-left-0 s-z-10"
                    style={{ "--0b879273": "0" }}
                  >
                    <span
                      data-v-2f9c23fd
                      className="mask s-w-full s-h-full s-opacity-10 s-bg-black-900 s-absolute s-left-0 s-top-0"
                      style={{ display: "none" }}
                    />
                    <span
                      data-v-2f9c23fd
                      className="feedback s-block s-bg-white s-bg-opacity-25 s-rounded-full s-mix-blend-overlay s-absolute"
                      style={{ display: "none" }}
                    />
                  </div>
                  {/**/}
                  <span
                    data-v-5a681009
                    className="s-icon-plus s-text-20px s-text-black-600"
                  />
                </button>
              </div>
              {/**/}
            </section>
            <section
              style={{ background: "#20232a" }}
              data-v-5a681009
              className="s-bet-amount s-ml-2 bg-black-100"
            >
              <dt data-v-5a681009 className="s-title s-font-normal">
                Stake
              </dt>
              <dd data-v-5a681009 className="s-input-box">
                <button
                  style={
                    bidPriceDisabled && theme == "light"
                      ? { background: "#d4e0e5", color: "black" }
                      : {}
                  }
                  data-v-bf7df09e
                  data-v-5a681009
                  onClick={(e) => {
                    if (betSlipObject?.bidPrice > 1) {
                      setBetSlipObject({
                        ...betSlipObject,
                        bidPrice: Number(betSlipObject?.bidPrice) - 1,
                      });
                    }
                  }}
                  className="btn s-btn-normal s-relative s-text-14px s-p-3 s-font-bold s-rounded s-flex s-justify-center s-items-center disabled:s-bg-black-300 dark:disabled:s-bg-black-700 disabled:s-text-black-600 dark:disabled:s-text-black-600 disabled:s-cursor-not-allowed s-overflow-hidden a active:s-bg-opacity-10 s-w-34px s-h-34px"
                  name="minus"
                  disabled={bidPriceDisabled}
                >
                  <div
                    data-v-2f9c23fd
                    data-v-bf7df09e
                    className="wrapper s-w-full s-h-full s-absolute s-overflow-hidden s-top-0 s-left-0 s-z-10"
                    style={{ "--0b879273": "0" }}
                  >
                    <span
                      data-v-2f9c23fd
                      className="mask s-w-full s-h-full s-opacity-10 s-bg-black-900 s-absolute s-left-0 s-top-0"
                      style={{ display: "none" }}
                    />
                    <span
                      data-v-2f9c23fd
                      className="feedback s-block s-bg-white s-bg-opacity-25 s-rounded-full s-mix-blend-overlay s-absolute"
                      style={{ display: "none" }}
                    />
                  </div>
                  {/**/}
                  <span
                    data-v-5a681009
                    className={`s-icon-minus s-text-20px ${
                      bidPriceDisabled ? "s-text-black-600" : ""
                    } `}
                  />
                </button>
                <span
                  data-v-5a681009
                  name="stake"
                  className="s-input-field is-focus"
                >
                  {betSlipObject?.bidPrice}
                </span>
                <button
                  style={
                    bidPriceDisabled && theme == "light"
                      ? { background: "#d4e0e5", color: "black" }
                      : {}
                  }
                  onClick={(e) => {
                    if (betSlipObject?.bidPrice > 0) {
                      setBetSlipObject({
                        ...betSlipObject,
                        bidPrice: Number(betSlipObject?.bidPrice) + 1,
                      });
                    }
                  }}
                  data-v-bf7df09e
                  data-v-5a681009
                  className="btn s-btn-normal s-relative s-text-14px s-p-3 s-font-bold s-rounded s-flex s-justify-center s-items-center disabled:s-bg-black-300 dark:disabled:s-bg-black-700 disabled:s-text-black-600 dark:disabled:s-text-black-600 disabled:s-cursor-not-allowed s-overflow-hidden a active:s-bg-opacity-10 s-w-34px s-h-34px"
                  name="plus"
                  disabled={bidPriceDisabled}
                >
                  <div
                    data-v-2f9c23fd
                    data-v-bf7df09e
                    className="wrapper s-w-full s-h-full s-absolute s-overflow-hidden s-top-0 s-left-0 s-z-10"
                    style={{ "--0b879273": "0" }}
                  >
                    <span
                      data-v-2f9c23fd
                      className="mask s-w-full s-h-full s-opacity-10 s-bg-black-900 s-absolute s-left-0 s-top-0"
                      style={{ display: "none" }}
                    />
                    <span
                      data-v-2f9c23fd
                      className="feedback s-block s-bg-white s-bg-opacity-25 s-rounded-full s-mix-blend-overlay s-absolute"
                      style={{ display: "none" }}
                    />
                  </div>
                  {/**/}
                  <span
                    data-v-5a681009
                    className={`s-icon-plus s-text-20px ${
                      bidPriceDisabled ? "s-text-black-600" : ""
                    } `}
                  />
                </button>
              </dd>
            </section>
          </div>
          <div data-v-5a681009>
            <div data-v-5a681009 className="s-mb-2 s-flex">
              <div className="s-flex s-flex-1 s-justify-between">
                {(profileData?.stake?.length > 0
                  ? profileData?.stake?.sort(function (a, b) {
                      return a - b;
                    })
                  : numberArray
                )
                  ?.slice(0, 4)
                  ?.map((res) => {
                    return (
                      <button
                        style={
                          theme == "light"
                            ? { background: "white", color: "black" }
                            : {}
                        }
                        onClick={() => {
                          if (activeInput == 1) {
                            setBetSlipObject({
                              ...betSlipObject,
                              odds: Number(res),
                            });
                          } else {
                            setBetSlipObject({
                              ...betSlipObject,
                              bidPrice: Number(res),
                            });
                          }
                        }}
                        data-v-bf7df09e
                        className="btn s-btn-normal s-relative s-text-14px s-p-3 s-font-bold s-rounded s-flex s-justify-center s-items-center disabled:s-bg-black-300 dark:disabled:s-bg-black-700 disabled:s-text-black-600 dark:disabled:s-text-black-600 disabled:s-cursor-not-allowed s-overflow-hidden a active:s-bg-opacity-10 s-w-80px s-h-31px s-text-17px s-border-0"
                        type="button"
                      >
                        <div
                          data-v-2f9c23fd
                          data-v-bf7df09e
                          className="wrapper s-w-full s-h-full s-absolute s-overflow-hidden s-top-0 s-left-0 s-z-10"
                          style={{ "--0b879273": "0" }}
                        >
                          <span
                            data-v-2f9c23fd
                            className="mask s-w-full s-h-full s-opacity-10 s-bg-black-900 s-absolute s-left-0 s-top-0"
                            style={{ display: "none" }}
                          />
                          <span
                            data-v-2f9c23fd
                            className="feedback s-block s-bg-white s-bg-opacity-25 s-rounded-full s-mix-blend-overlay s-absolute"
                            style={{ display: "none" }}
                          />
                        </div>
                        +{res}
                      </button>
                    );
                  })}

                <button
                  style={
                    theme == "light"
                      ? { background: "white", color: "black" }
                      : {}
                  }
                  onClick={() => setSetting(true)}
                  data-v-bf7df09e
                  className="btn s-btn-normal s-relative s-text-14px s-p-3 s-font-bold s-rounded s-flex s-justify-center s-items-center disabled:s-bg-black-300 dark:disabled:s-bg-black-700 disabled:s-text-black-600 dark:disabled:s-text-black-600 disabled:s-cursor-not-allowed s-overflow-hidden a active:s-bg-opacity-10 s-w-31px s-h-31px s-border-0"
                  type="button"
                >
                  <div
                    data-v-2f9c23fd
                    data-v-bf7df09e
                    className="wrapper s-w-full s-h-full s-absolute s-overflow-hidden s-top-0 s-left-0 s-z-10"
                    style={{ "--0b879273": "0" }}
                  >
                    <span
                      data-v-2f9c23fd
                      className="mask s-w-full s-h-full s-opacity-10 s-bg-black-900 s-absolute s-left-0 s-top-0"
                      style={{ display: "none" }}
                    />
                    <span
                      data-v-2f9c23fd
                      className="feedback s-block s-bg-white s-bg-opacity-25 s-rounded-full s-mix-blend-overlay s-absolute"
                      style={{ display: "none" }}
                    />
                  </div>
                  {/**/}
                  <span className="s-icon-setting s-text-17px" />
                </button>
              </div>
            </div>
            <div data-v-5a681009 className="s-flex">
              <div className="s-flex s-flex-1 s-flex-wrap">
                {numberArrayCount?.map((res) => {
                  return (
                    <button
                      onClick={() =>
                        setBetSlipObject((prev) => {
                          return {
                            ...prev,
                            bidPrice:
                              Number(prev?.bidPrice) > 0
                                ? Number(String(prev?.bidPrice) + String(res))
                                : Number(res),
                          };
                        })
                      }
                      data-v-bf7df09e
                      style={
                        theme == "light"
                          ? {
                              background: "#20232a",
                              border: "1px solid #20232a",
                            }
                          : {}
                      }
                      className="btn s-btn-normal s-relative s-text-14px s-p-3 s-font-bold s-rounded s-flex s-justify-center s-items-center disabled:s-bg-black-300 dark:disabled:s-bg-black-700 disabled:s-text-black-600 dark:disabled:s-text-black-600 disabled:s-cursor-not-allowed s-overflow-hidden a active:s-bg-opacity-10 s-w-2/12 s-h-40px s-flex s-justify-center s-items-center s-text-17px s-font-normal s-border s-border-white s-bg-black-100 dark:s-border-black-900 dark:s-bg-black-700 s-text-global-font-default-light dark:s-text-global-font-default-dark s-rounded"
                      type="button"
                    >
                      <div
                        data-v-2f9c23fd
                        data-v-bf7df09e
                        className="wrapper s-w-full s-h-full s-absolute s-overflow-hidden s-top-0 s-left-0 s-z-10"
                        style={{ "--0b879273": "0" }}
                      >
                        <span
                          data-v-2f9c23fd
                          className="mask s-w-full s-h-full s-opacity-10 s-bg-black-900 s-absolute s-left-0 s-top-0"
                          style={{ display: "none" }}
                        />
                        <span
                          data-v-2f9c23fd
                          className="feedback s-block s-bg-white s-bg-opacity-25 s-rounded-full s-mix-blend-overlay s-absolute"
                          style={{ display: "none" }}
                        />
                      </div>
                      {res}
                    </button>
                  );
                })}
              </div>
              <button
                onClick={() => {
                  if (!betSlipObject?.bidPrice) return;
                  const newValue = String(betSlipObject?.bidPrice).slice(0, -1);
                  setBetSlipObject({
                    ...betSlipObject,
                    bidPrice: Number(newValue),
                  });
                }}
                data-v-bf7df09e
                style={
                  theme == "dark"
                    ? { background: "#064b4d", border: "1px solid #1b1c21" }
                    : {
                        background: "rgb(32, 35, 42)",
                        color: "white",
                        border: "1px solid rgb(32, 35, 42)",
                      }
                }
                className="btn s-btn-normal s-relative s-text-14px s-p-3 s-font-bold s-rounded s-flex s-justify-center s-items-center disabled:s-bg-black-300 dark:disabled:s-bg-black-700 disabled:s-text-black-600 dark:disabled:s-text-black-600 disabled:s-cursor-not-allowed s-overflow-hidden a active:s-bg-opacity-10 s-icon-backspace s-w-20 s-text-24px s-font-bold s-border-solid s-border-l s-border-white s-rounded s-bg-black-100 dark:s-border-black-900 dark:s-bg-black-700 s-text-global-font-default-light dark:s-text-global-font-default-dark"
                type="button"
              >
                <div
                  data-v-2f9c23fd
                  data-v-bf7df09e
                  className="wrapper s-w-full s-h-full s-absolute s-overflow-hidden s-top-0 s-left-0 s-z-10"
                  style={{ "--0b879273": "0" }}
                >
                  <span
                    data-v-2f9c23fd
                    className="mask s-w-full s-h-full s-opacity-10 s-bg-black-900 s-absolute s-left-0 s-top-0"
                    style={{ display: "none" }}
                  />
                  <span
                    data-v-2f9c23fd
                    className="feedback s-block s-bg-white s-bg-opacity-25 s-rounded-full s-mix-blend-overlay s-absolute"
                    style={{ display: "none" }}
                  />
                </div>
                {/**/}
              </button>
            </div>
          </div>
          {/**/}

          <div
            data-v-5a681009
            className="s-mt-7px s-flex s-justify-between s-items-center"
          >
            <div data-v-5a681009>{/**/}</div>
            <div
              data-v-5a681009
              className="s-flex s-gap-3px s-items-center s-text-black-500"
            >
              <span data-v-5a681009 className="s-icon-min-max s-text-14px" />
              <span data-v-5a681009 className="s-text-12px">
                Min/Max
              </span>
              <mark
                data-v-5a681009
                className="s-font-bold s-bg-transparent s-text-12px s-text-black-500"
              >
                {formatWithCommas(limit?.minAmount)}/
                {formatWithCommas(limit?.maxAmount)}
              </mark>
            </div>
          </div>

          <button
            onClick={() => {
              placeBet();
            }}
            disabled={bidPriceDisabled}
            data-v-bf7df09e
            data-v-5a681009
            className="btn s-btn-normal s-relative s-text-14px s-p-3 s-font-bold s-rounded s-flex s-justify-center s-items-center disabled:s-bg-black-300 dark:disabled:s-bg-black-700 disabled:s-text-black-600 dark:disabled:s-text-black-600 disabled:s-cursor-not-allowed s-overflow-hidden a active:s-bg-opacity-10 s-w-full s-h-40px s-mt-2 s-text-17px s-font-bold"
            type="submit"
          >
            <div
              data-v-2f9c23fd
              data-v-bf7df09e
              className="wrapper s-w-full s-h-full s-absolute s-overflow-hidden s-top-0 s-left-0 s-z-10"
              style={{ "--0b879273": "0" }}
            >
              <span
                data-v-2f9c23fd
                className="mask s-w-full s-h-full s-opacity-10 s-bg-black-900 s-absolute s-left-0 s-top-0"
                style={{ display: "none" }}
              />
              <span
                data-v-2f9c23fd
                className="feedback s-block s-bg-white s-bg-opacity-25 s-rounded-full s-mix-blend-overlay s-absolute"
                style={{ display: "none" }}
              />
            </div>
            Place Bet{" "}
          </button>
          <div data-v-5a681009 style={betLoader ? {} : { display: "none" }}>
            <div
              data-v-5a681009
              className="s-absolute s-z-10 s-top-0 s-left-0 s-w-full s-h-full s-bg-black-800 s-opacity-80 s-rounded-t-5px"
            />
            <div
              data-v-5a681009
              className="s-absolute s-z-10 s-top-0 s-left-0 s-w-full s-h-full s-flex s-items-center s-justify-center"
            >
              <img
                data-v-5a681009
                width={147}
                height={124}
                src={cdnImg("/assets/IconBetting/loading-bet.webp")}
                alt
              />
            </div>
          </div>
        </div>
        <div
          data-v-5a681009
          className="s-bet-slip-gradient s-absolute s-w-full s-h-120px dark:s-h-64px s-top-13px dark:-s-top-17px -s-translate-y-1/2"
          style={{ display: showBetDialog ? "block" : "none" }}
        />
      </div>
      <div
        data-v-f50a5648
        className="s-fixed s-top-0 s-left-0 s-w-full s-h-full"
        style={{ zIndex: 71, display: "none" }}
      />
      {setting && <StackSetting handleStackSetting={setSetting} />}
    </>
  );
};

export default BetSlip;
